import React from 'react'
import { PaddedContainer } from '@/atoms/PaddedContainer'
import { CastSection } from './CastSection'
import { OverviewSection } from './OverviewSection'
import { RatingsSection } from './RatingsSection'

export const AboutTab: React.FC = () => {
  return (
    <div className="flex flex-col">
      <PaddedContainer fluid>
        <OverviewSection />
        <RatingsSection />
      </PaddedContainer>
      <CastSection />
    </div>
  )
}
